import gql from "graphql-tag";

export const MY_TAX_GET_ELIGIBLE_COSTS_DECLARATION = gql`
  query taxDeclarationEligibleCosts($_id: Int!) {
    taxDeclarationEligibleCosts(_id: $_id) {
      dateOfDeclaration
      state
      independentIncome10Percent
      independentIncomeAmount
      independentIncomeCost10Percent
      independentIncomeCostAmount
      notIndependentIncomeCostAmount
      woCertificateIndependentCost
      woCertificateNotIndependentCost
      appartamentRentalCost
      postingStatementCost
      foreignServiceCost
      validUntilWithdrawn
    }
  }
`;
